import { render, staticRenderFns } from "./tendency-chart.vue?vue&type=template&id=2885b36d&scoped=true&"
import script from "./tendency-chart.vue?vue&type=script&lang=js&"
export * from "./tendency-chart.vue?vue&type=script&lang=js&"
import style0 from "./tendency-chart.vue?vue&type=style&index=0&id=2885b36d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2885b36d",
  null
  
)

export default component.exports